<app-loading *ngIf="cargando"></app-loading>
<div *ngIf="!cargando">
  <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTAAUTORIZACIONES.LBL_AUTORIZACION' | translate }}</label>
          <p-dropdown disableTab  id="idAutorizacion{{fluVentaPaso.codigo}}" name="nomAutorizacion{{fluVentaPaso.codigo}}"
                      [options]="lisAutorizacionSelect" filter="filter"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                       formControlName="idAutorizacion"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idAutorizacion.invalid">
            {{ 'FLUJOVENTAAUTORIZACIONES.LBL_AUTORIZACION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTAAUTORIZACIONES.LBL_DESCRIPCION' | translate }}</label>
          <textarea type="text" pInputText id="descripcion"
                    name="nomdescripcion" maxlength="500"
                    formControlName="descripcion"
                    autocomplete="off"
          ></textarea>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.descripcion.invalid">
            {{ 'FLUJOVENTAAUTORIZACIONES.LBL_DESCRIPCION' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTAAUTORIZACIONES.LBL_PLANTILLA' | translate }}</label>
          <p-dropdown disableTab  id="idPlantilla{{fluVentaPaso.codigo}}" name="nomPlantilla{{fluVentaPaso.codigo}}"
                      [options]="lisPlantillaSelect" filter="filter"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                      formControlName="idPlantilla"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idPlantilla.invalid">
            {{ 'FLUJOVENTAAUTORIZACIONES.LBL_PLANTILLA' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTAAUTORIZACIONES.LBL_FASE' | translate }}</label>
          <p-dropdown disableTab  id="idFase{{fluVentaPaso.codigo}}" name="nomFase{{fluVentaPaso.codigo}}"
                      [options]="lisFasesSelect" filter="filter"
                      placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                      emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                      optionValue="value"
                      optionLabel="label"
                       formControlName="idFase"
          ></p-dropdown>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.idFase.invalid">
            {{ 'FLUJOVENTAAUTORIZACIONES.LBL_FASE' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <label>* {{ 'FLUJOVENTAAUTORIZACIONES.LBL_TIPODEPRODUCTO' | translate }}</label>
          <p-multiSelect id="tipoProceso" name="nomTipoProceso" [options]="listasTiposProductosBancarios"
                         defaultLabel="{{ 'LBL_SELECCIONE' | translate}}"
                         selectedItemsLabel="{0} {{ 'LBL_ELEMENTOSSELECCIONADOS' | translate}}"
                         formControlName="tipoProceso"
                         emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                         optionValue="value"
                         optionLabel="label"
          ></p-multiSelect>
          <div class="p-message p-messages-error p-corner-all" *ngIf="submitted && f.tipoProceso.invalid">
            {{ 'FLUJOVENTAAUTORIZACIONES.LBL_TIPODEPRODUCTO' | translate}} {{ 'LBL_REQUERIDO' | translate}}
          </div>
        </div>
      </div>
    </div>
    <div class="grid form-group">
      <div class="col-12 md:col-6 lg:col-6">
        <div class="div-form">
          <p-checkbox
            label="{{ 'FLUJOVENTAAUTORIZACIONES.LBL_REQUERIDAALINICIO' | translate }}"
            binary="true"
            id="gt{{ fluVentaPaso.codigo }}"
            name="nomGT{{ fluVentaPaso.codigo }}"
            formControlName="indicadorRequeridaInicio"
          ></p-checkbox>
        </div>
      </div>
    </div>
    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <button icon="fa fa-plus" label="{{'BTN_AGREGAR' | translate }}"
                type="button" (click)="onSubmit()"
                pButton></button>
      </div>
    </div>
  </form>


  <div class="grid">
    <div class="col-12 md:col-6 lg:col-6">
    </div>
    <div class="col-12 md:col-6 lg:col-6">
      <input type="text" pInputText size="40" placeholder="{{ 'LBL_BUSCAR' | translate }}"
             (input)="dt.filterGlobal($event.target.value, 'contains')">
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table [columns]="columnas" #dt
               [value]="lisFlujoAutorizacion"
               [paginator]="true" [rows]="10"  paginatorPosition="bottom">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
              {{col.header}}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td>{{row.autorizacion ?? '-'}}</td>
            <td>{{row.descripcion ?? '-'}}</td>
            <td>{{row.plantilla ?? '-'}}</td>
            <td>{{row.fase ?? '-'}}</td>
            <td class="text-center">
              <p-checkbox [(ngModel)]="row.indicadorRequeridaInicio" binary="true" [ngModelOptions]="{standalone: true}"
                          disabled="true"></p-checkbox>
            </td>
            <td>{{row.tipoProceso ?? '-'}}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button type="button" class="p-button p-button-success btn" icon="fa fa-trash" data-toggle="tooltip"
                        title="{{'BTN_INHABILITAR' | translate}}" pButton
                        (click)="inhablitar(row)"></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length">
              {{ 'MSG_NOHAYREGISTROS' | translate}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

</div>


<p-confirmDialog #cd key="flujoVentaAutorizacion{{fluVentaPaso.codigo}}">
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
